import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail } from "lucide-react";
import SEO from "../../components/SEO";
import PageHeader from "../../components/PageHeader";
import { Reveal } from "../../components/Reveal";
import api, { formatApiError } from "../../lib/api";

const inputCls = "w-full border border-navy/20 bg-white px-4 py-3.5 text-sm text-navy focus:outline-none focus:border-rouge transition-colors duration-300";
const labelCls = "block font-heading uppercase tracking-wider text-xs text-navy/70 mb-1.5";

export default function EspaceMotDePasseOublie() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <SEO title="Mot de passe oublié — Espace Licencié" />
      <PageHeader kicker="Espace Licencié" title="Mot de passe oublié" />

      <section className="py-16 sm:py-24 bg-mist">
        <div className="max-w-md mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="bg-white border border-navy/10 p-8 sm:p-10">
              {done ? (
                <div data-testid="forgot-success">
                  <div className="w-14 h-14 bg-green-100 text-green-700 flex items-center justify-center mb-6">
                    <Mail size={24} />
                  </div>
                  <p className="text-navy leading-relaxed">{done}</p>
                  <p className="mt-3 text-sm text-steel">Pensez à vérifier vos courriers indésirables.</p>
                </div>
              ) : (
                <form onSubmit={submit} data-testid="forgot-form">
                  <p className="text-steel text-sm leading-relaxed mb-6">
                    Saisissez l'adresse email de votre compte. Nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe.
                  </p>
                  <div className="mb-6">
                    <label className={labelCls} htmlFor="forgot-email">Email</label>
                    <input id="forgot-email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} autoComplete="email" />
                  </div>
                  {error && <p data-testid="forgot-error" className="mb-6 bg-rouge/15 border border-rouge/40 text-rouge text-sm px-4 py-3">{error}</p>}
                  <button
                    type="submit"
                    disabled={busy}
                    data-testid="forgot-submit"
                    className="w-full inline-flex items-center justify-center gap-2.5 bg-rouge text-white font-heading uppercase tracking-wider text-sm px-8 py-4 hover:bg-navy disabled:opacity-60 transition-colors duration-300"
                  >
                    {busy && <Loader2 size={16} className="animate-spin" />}
                    Envoyer le lien
                  </button>
                </form>
              )}
              <p className="mt-6 pt-6 border-t border-navy/10 text-sm">
                <Link to="/espace/connexion" className="text-navy/70 hover:text-rouge transition-colors" data-testid="forgot-back-login">
                  ← Retour à la connexion
                </Link>
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
